/**
 * RegisteredNoVisitCard — جولة تصحيح 2026-10-13 (بند 3ج): فئة مستقلة
 * «سجّلوا ولم يزوروا» خارج الشرائح تماماً (core.customer_population.
 * registered_no_visit — مصدرها datasets.type=cust، is59/is59x، بلا أي
 * فاتورة مدفوعة طوال العمر). بطاقة واحدة بجانب الخريطة الزمنية للشرائح
 * (لا داخلها)، رقمها يفتح نفس CustomerListModal (نسخ/تصدير/مسودة) —
 * kind="registered_no_visit" في routes/customers_unified_list.py.
 */
import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import CustomerListModal from "../components/CustomerListModal";

export function RegisteredNoVisitCard() {
  const [count, setCount] = useState(null);
  const [err, setErr] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    let cancelled = false;
    api.get("/customers/unified-list", { params: { kind: "registered_no_visit", page_size: 1 } })
      .then((r) => { if (!cancelled) setCount(r.data?.total ?? 0); })
      .catch((e) => { if (!cancelled) setErr(e?.response?.data?.detail || "تعذّر التحميل"); });
    return () => { cancelled = true; };
  }, []);

  return (
    <div data-testid="registered-no-visit-card" dir="rtl"
         style={{ background: "#fff", border: "1px solid rgba(180,83,9,0.25)",
                  borderRadius: 16, padding: "16px 20px", marginBottom: 16,
                  boxShadow: "0 1px 3px rgba(180,83,9,0.06)" }}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 10 }}>
        <div>
          <div style={{ fontSize: 16, fontWeight: 800, color: "#3D2A1C" }}>سجّلوا ولم يزوروا</div>
          <div style={{ fontSize: 11, color: "#78716C", marginTop: 2 }}>
            سجّلوا (باركود الافتتاح أو ما شابه) ولا توجد لهم فاتورة مدفوعة بعد — خارج كل الشرائح والقاعدة الكاملة
          </div>
          {err && <div data-testid="registered-no-visit-error" style={{ fontSize: 12, color: "#B45309", marginTop: 4 }}>{err}</div>}
        </div>
        <button type="button" data-testid="registered-no-visit-count-btn"
                onClick={() => setOpen(true)}
                style={{
                  display: "flex", flexDirection: "column", alignItems: "center",
                  gap: 2, padding: "10px 20px", borderRadius: 12,
                  border: "1.5px solid #B45309", background: "#FFFBEB", cursor: "pointer",
                }}>
          <span data-testid="registered-no-visit-count" style={{ fontSize: 24, fontWeight: 900, color: "#92400E",
                   fontVariantNumeric: "lining-nums tabular-nums" }}>
            {count != null ? count.toLocaleString("en-US") : "—"}
          </span>
          <span style={{ fontSize: 10, color: "#92400E" }}>عميل</span>
        </button>
      </div>
      {open && (
        <CustomerListModal
          kind="registered_no_visit"
          title="سجّلوا ولم يزوروا"
          onClose={() => setOpen(false)}
        />
      )}
    </div>
  );
}

export default RegisteredNoVisitCard;
